/* Shared by the server and preview canvases, so the editor and the live page
   agree on which sections are above the fold and what each section's id is. */

/** How many countable organisms load eagerly. Matches the v2 canvas. */
export const ABOVE_THE_FOLD_COUNT = 2;

export const VERTICAL_SPACER = "DDS_VERTICAL_SPACER";

/** Types that never hold the LCP image, so they must not consume a slot.
    The spacer is v2's COUNTER_EXCLUDED VERTICALSPACER. */
export const NON_COUNTABLE_TYPES: readonly string[] = [VERTICAL_SPACER];

/**
 * The section's anchor id, and the `id` prop the organism should receive.
 *
 * The section id is derived from the type and the index — never authored — and
 * the authored value goes to the organism untouched. Deriving it is what stops
 * the two colliding, so faq reads `id` as its accordion group name and two faq
 * blocks on one page no longer close each other's answers. The authored value
 * cannot double as an anchor anyway: a spacer's is a CLASS NAME shared by every
 * spacer (prod's own fixture sets "verticalSpacer").
 */
export function resolveSectionIds(
  type: string,
  authoredId: unknown,
  index: number
): { sectionId: string; organismId?: unknown } {
  return {
    sectionId: `dtv3-${type.toLowerCase().replace(/_/g, "-")}-${index}`,
    organismId: authoredId
  };
}
